// src/modules/operaciones/inventarios/utils/exportarTraslados.js
//
// Exporta la lista de traslados a un archivo Excel (.xls) generado como HTML con estilos en línea.

/* =========================================================================
   EXPORTACIÓN A EXCEL (XML NATIVO PARA MANTENER ESTILOS)
   ========================================================================= */
export const exportarTrasladosAExcel = (filas) => {
  let html = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
      <meta charset="utf-8">
      <!--[if gte mso 9]>
      <xml>
        <x:ExcelWorkbook>
          <x:ExcelWorksheets>
            <x:ExcelWorksheet>
              <x:Name>Traslados</x:Name>
              <x:WorksheetOptions>
                <x:DisplayGridlines/>
              </x:WorksheetOptions>
            </x:ExcelWorksheet>
          </x:ExcelWorksheets>
        </x:ExcelWorkbook>
      </xml>
      <![endif]-->
      <style>
        table { border-collapse: collapse; font-family: Calibri, Arial, sans-serif; font-size: 11pt; }
        /* Título principal combinado */
        td.titulo {
          background-color: #92D050; 
          color: #000000;
          font-weight: bold;
          font-size: 14pt;
          text-align: center;
          vertical-align: middle;
          border: 1px solid #000000;
          height: 30px;
        }
        /* Encabezados de columnas */
        th {
          background-color: #92D050;
          color: #000000;
          font-weight: bold;
          border: 1px solid #000000;
          padding: 4px;
          text-align: center;
          vertical-align: middle;
        }
        /* Celdas de datos */
        td {
          border: 1px solid #000000;
          padding: 4px;
          vertical-align: middle;
          mso-number-format: "\\@"; /* Fuerza formato de texto */
        }
        .center { text-align: center; }
        .left { text-align: left; }
      </style>
    </head>
    <body>
      <table>
        <tr>
          <td colspan="7" class="titulo">TRASLADOS PENDIENTES - SURTIDOR</td>
        </tr>
        <tr>
          <th>Número</th>
          <th>Fecha</th>
          <th>Concepto</th>
          <th>Origen</th>
          <th>Destino</th>
          <th>Confirmado</th>
          <th>Anulado</th>
        </tr>
  `;

  filas.forEach((t) => {
    const fechaStr = t.FECHA ? String(t.FECHA).split('T')[0] : '';
    const partes = fechaStr.split('-');
    const fechaMostrar = partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : fechaStr;

    html += `
        <tr>
          <td class="center">${t.NUMERO || ''}</td>
          <td class="center">${fechaMostrar}</td>
          <td class="left">${t.CONCEPTO || ''}</td>
          <td class="center">${t.ORIGEN || ''}</td>
          <td class="center">${t.DESTINO || ''}</td>
          <td class="center">${t.CONFIRMADO === 'N' ? 'PENDIENTE' : 'CONFIRMADO'}</td>
          <td class="center">${t.ANULADO === 'S' ? 'ANULADO' : 'PENDIENTE'}</td>
        </tr>
    `;
  });

  html += `
      </table>
    </body>
    </html>
  `;

  const blob = new Blob([html], { type: 'application/vnd.ms-excel' });
  const url = URL.createObjectURL(blob);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = `Traslados_${new Date().toISOString().slice(0, 10)}.xls`;
  document.body.appendChild(enlace);
  enlace.click();
  enlace.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};